import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter } from 'react-router-dom';
import './index.css';
import { Provider } from 'react-redux';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import ViewsLayout from './layouts';
import configureStore from './redux/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import { setTranslations, setDefaultLanguage } from 'react-multi-lang';
import en from './translations/en.json';
import './assets/CSS/navbar.css';
import './assets/CSS/HeroSection.css';
import './assets/CSS/ToolsSection.css';
import './assets/CSS/riskManagementSection.css';
import './assets/CSS/NewsCarousel.css';
import './assets/CSS/testimonial.css';
import './assets/CSS/maximizingImpact.css';
import './assets/CSS/footer.css';
import './assets/CSS/partners.css';
import './assets/CSS/toolsManagement.css';
import './assets/CSS/droughtInsights.css';
import './assets/CSS/Filter.css';
import './assets/CSS/Common.css';
import './assets/CSS/Custom.css';
import './assets/CSS/NewsFeed.css';
import './assets/CSS/contigencyPlan.css';
import './assets/CSS/dmsLandingpage.css';
import './assets/CSS/whatWeOffer.css';
import 'font-awesome/css/font-awesome.min.css';
import './i18n'
setTranslations({ en });
setDefaultLanguage('en');

ReactDOM.render(
  <Provider store={configureStore()}>
    <BrowserRouter>
      <Route path="/" component={ViewsLayout} />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
